<template>
    <div class="info-mosaics-container">
        <div class="global-mosaic-container">
          <div class="filter-global-container">
            <div class="panel-content-line">
                <input type="checkbox" id="params-stations-checkbox" name="params-stations-checkbox" v-model="paramsStations">
                <label for="params-stations-checkbox">Estaciones Mar Menor</label>
            </div>
            <div class="panel-content-line">
                <input type="checkbox" id="params-density-checkbox" name="params-density-checkbox" v-model="paramsDensity">
                <label for="params-density-checkbox">Mapas de densidad</label>
                <div v-if="paramsDensity">
                  <select id="selected-param" class="custom-select" v-model="densitySelectedParam">
                  <option value="Clorofila_surface">Clorofila Superficie</option>
                  <option value="Clorofila_bottom">Clorofila fondo</option>
                  <option value="ConOxigenoDisuelto_surface">Concentración Oxígeno superficie</option>
                  <option value="ConOxigenoDisuelto_bottom">Concentración Oxígeno fondo</option>
                  <option value="PorOxigenoDisuelto_surface">Porcentage Oxígeno superficie</option>
                  <option value="PorOxigenoDisuelto_bottom">Porcentage Oxígeno fondo</option>
                  <option value="Salinidad_surface">Salinidad superficie</option>
                  <option value="Salinidad_bottom">Salinidad fondo</option>
                </select>
                </div>
            </div>
          </div>
          <form :model="form" ref="form" v-on:submit.prevent>
            <div class="filter-date-container">
              <div class="panel-content-line filter-element">
                  <label for="params-start-date">Fecha inicio</label>
                  <br>
                  <input type="date" id="params-start-date" name="params-start-date" class="custom-input-text" v-model="form.paramsStartDate">              
              </div>
              <div class="panel-content-line filter-element">
                  <label for="params-end-date">Fecha fin</label>
                  <br>
                  <input type="date" id="params-end-date" name="params-end-date" class="custom-input-text" v-model="form.paramsEndDate">              
              </div>
            </div>
            <div class="panel-content-line filter-element">
              <label for="campaign-filter">Búsqueda de datos de campaña</label>
              <br>
              <input type="text" id="campaign-filter" name="campaign-filter" class="custom-input-text" v-model="form.campaignFilter">               
            </div>
            <br>
            <button class="btn-new ml-auto" v-on:click="getFilteredParams">Filtrar</button>
          </form>
          <div class="campaign-list">
            <div class="campaign-list-title">Histórico de datos</div><br>
            <div class="panel-content-line">
              <div
                class="campaign-list-item"
                v-for="campaign in paramsCampaignsListFiltered"
                :key="campaign.id"
                v-bind:class="{ 'campaign-list-item-selected': campaign.id==paramsCampaignSelected.id }"
                @click="selectCampaign(campaign.id)"
              >
                {{ campaign.name }}
              </div>
            </div>
          </div>
        </div>
    </div>
</template>

<script>
  import {getData} from './../../services/api'

  export default {
    name: 'filterPanelParams',
    data() {
        return {
          form: {
            paramsStartDate: '',
            paramsEndDate: '',
            campaignFilter: ''
          }
        }
    },
    computed: {
      paramsStations: {
          set () { this.$store.dispatch('changeParamsStationsOrDensityMaps', {stationsOrDensity: 'stations'}); },
          get () { return this.$store.state.mapLayers.layerParams.paramsStations }
      },
      paramsDensity: {
          set () { this.$store.dispatch('changeParamsStationsOrDensityMaps', {stationsOrDensity: 'density'}); },
          get () { return this.$store.state.mapLayers.layerParams.paramsDensityMaps }
      },
      paramsCampaignsList: {
          set (campaignsList) { this.$store.dispatch('changeParamsCampaignsList', {paramsCampaignsList: campaignsList}); },
          get () { return this.$store.state.mapLayers.layerParams.paramsCampaignsList }
      },
      paramsCampaignsListFiltered: {
          set (campaignsList) { this.$store.dispatch('changeParamsCampaignsListFiltered', {paramsCampaignsListFiltered: campaignsList}); },
          get () { return this.$store.state.mapLayers.layerParams.paramsCampaignsListFiltered }
      },
      paramsCampaignSelected: {
          set (campaignSelected) { this.$store.dispatch('changeParamsCampaignSelected', {paramsCampaignSelected: campaignSelected}); },
          get () { return this.$store.state.mapLayers.layerParams.paramsCampaignSelected }
      },
      densitySelectedParam: {
          set (selectedParam) { this.$store.dispatch('changeDensitySelectedParam', {densitySelectedParam: selectedParam}); },
          get () { return this.$store.state.mapLayers.layerParams.densitySelectedParam }
      }
    },
    beforeMount () {
        this.getParamsData()  
    },
    methods: {
      getParamsData: function () {
          var url = 'mmdata/params-campaign-datas/'
          getData(url).then(res=> {
              this.paramsCampaignsList = res.data.paramsCampaignDatas
              this.paramsCampaignsListFiltered = res.data.paramsCampaignDatas.reverse()
              this.selectCampaign()
          })       
      },
      getFilteredParams: function () {
        var start = '2000-01-01'
        var end = '3000-01-01'
        var campFilter = 'no filter'
        if(this.form.paramsStartDate != '') start = this.form.paramsStartDate
        if(this.form.paramsEndDate != '') end = this.form.paramsEndDate
        if(this.form.campaignFilter != '') campFilter = this.form.campaignFilter
        var url = 'mmdata/params-campaign-datas-filtered/' + start + '/' + end + '/' + campFilter + '/'

        getData(url).then(res=> {
          this.paramsCampaignsListFiltered = res.data.paramsCampaignDatas
          this.selectCampaign()
        })
        .catch(error => {
          this.$noty.error("Error")
        })     
      },
      selectCampaign: function (campaignDataId) {
        if (campaignDataId){
          for (var i=0; i<this.paramsCampaignsList.length; i++){
            if(this.paramsCampaignsList[i].id==campaignDataId){
              this.paramsCampaignSelected = this.paramsCampaignsList[i]
            }
          }
        }
        else {
          if(this.paramsCampaignsListFiltered){
            for (var i=0; i<this.paramsCampaignsListFiltered.length; i++){
              if(i==0){
                this.paramsCampaignSelected = this.paramsCampaignsListFiltered[i]
              }
              else if (this.paramsCampaignsListFiltered[i].id > this.paramsCampaignSelected.id){
                this.paramsCampaignSelected = this.paramsCampaignsListFiltered[i]
              }
            }
          }
        }
      }
    }
  }
</script>

<style scoped>
  .info-mosaics-container {
    width: 100%;
    padding: 0px 10px 10px 18px;
  }
  .global-mosaic-container {
    display: flex;
    flex-direction: column;
  }
  .panel-content-line{
    font-size: small;
    line-height: 80%;
  }
  .filter-date-container {
    display: flex;
    flex-direction: row;
    margin-bottom: 1em;
    padding-bottom: 1rem;
    border-bottom: solid 1px lightgrey;
  }
  .filter-global-container {
    margin-bottom: 1em;
    padding-bottom: 1rem;
    border-bottom: solid 1px lightgrey;
  }
  .filter-element {
    flex: 1;
    margin: 0.3rem;
  }
  .custom-input-text{
    background-color: #f9f9f9;
    font-size: 12px;
    width: 100%;
    border: 1px solid #ced4da;
    border-radius: .25rem;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    padding: .375rem 1.75rem .375rem .75rem;
  }
  .campaign-list{
    border-top: solid 2px #00a7e3;
    margin-top: 20px;
    padding-top: 10px;
  }
  .campaign-list-title{
    font-weight: 600;
    color: #00a7e3;
    margin-bottom: -10px;
  }
  .campaign-list-item {
    margin-bottom: 10px;
    cursor: pointer;
  }
  .campaign-list-item-selected {
    color: #00a7e3;
  }
</style>


// WEBPACK FOOTER //
// src/components/map/FilterPanelParams.vue